/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function AddAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Comms/Phones/AddPhoneNumber/Content/AddAction",
  onSubmit,
  isSubmitting
  
}) {
let phoneNumberSubmitData = fromData.useDataSubmit({ viewPath,
context: 'phone_number',
})
let phoneNumberIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'phone_number',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 marginTop={dtSpaceS}
 text="Add phone number"
 type="primary"
 data="phone_number"
 onClick={phoneNumberSubmitData}
 disabled={phoneNumberIsSubmittingData}
/>
{children}
</React.Fragment>)
}